import { defineStore } from "pinia";

interface UserInfo {
  tenantId?: string;
  [key: string]: any;
}

interface UserState {
  token: string;
  userInfo: UserInfo;
}

export const userStore = defineStore({
  id: "user",
  persist: true,
  state: (): UserState => ({
    token: "",
    userInfo: {
      tenantId: "",
      userInfo: {},
      token: '',
    },
  }),
  getters: {
    getToken(): string {
      return this.token;
    },
  },
  actions: {
    login(data: any) {
      this.userInfo = data;
      this.token = data.token;
      // const { token, tenantId } = data;
    },
    setToken(token: string) {
      this.token = token;
      localStorage.setItem("token", token);
    },
    setUserInfo(userInfo: any) {
      this.userInfo = userInfo;
    },
    loginOut() {
      this.$reset();
    }
  },
});
